import { fetchContractStatuses } from '../../../services/api/common';

export const CONTRACT_STATUS_IS_SIGNED = 'ISSIGNED'; // Договор подписан

export const contractStatus = {
    namespaced: true,
    state: {
        statuses: [],
    },
    mutations: {
        save(state, data) {
            state.statuses = data;
        }
    },
    actions: {
        fetchStatuses({ commit, dispatch }, values) {
            return fetchContractStatuses()
                .then((res) => {
                    commit('save', res.data);

                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    throw res;
                });
        }
    },
    getters: {
        isFetched({ statuses }) {
            return !!Object.keys(statuses).length;
        },
        statusesObject({ statuses }) {
            return statuses.reduce((items, item) => {
                items[item.value.trim().toUpperCase()] = item.id;
                return items;
            }, {});
        },
        statusNamesObject({ statuses }) {
            return statuses.reduce((items, item) => {
                items[item.id] = item.name;
                return items;
            }, {});
        },
        isSignedId({ statuses }, { statusesObject }) {
            return statusesObject[CONTRACT_STATUS_IS_SIGNED];
        }
    }
};



// WEBPACK FOOTER //
// ./src/modules/home/contractStatus/store.js